import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ourStaff from '../../../helpers/ourStaff';

import TdsDashboard from './Dashboard';
import NoMatch from '../../NoMatch';

const championshipsByPlatform = { 'mpg': 1, 'mln': 2, 'mgd': 3};
const Tds = props => (
    <div id="tds">
        { !props.location.search ? (
            <Redirect to={{
                pathname: '/tds',
                search: `?championship=${championshipsByPlatform[props.user.mainPlatform]}`,
            }}/>
        ) : (
            <Switch>
                <Route exact path='/tds' component={TdsDashboard} />
                <Route component={NoMatch} />
            </Switch>
        )}
    </div>
);

Tds.propTypes = {
    user: PropTypes.object.isRequired
};

export default connect(
    state => ({ user: ourStaff[state.authentication.userId] || state.authentication.user || {} })
)(Tds);



// WEBPACK FOOTER //
// ./src/pages/Tools/Tds/index.js